<template>
	<v-container
		v-if="show"
		class="px-0"
	>
		<v-container
			v-if="typeof report === 'string' || report instanceof String"
		>
			<v-row>
				<v-text-field
					:model-value="$gettext(report)"
					variant="outlined"
					readonly
					hide-details
				/>
			</v-row>
		</v-container>
		<v-container
			v-else
			class="px-0"
		>
			<v-row>
				<v-col>
					<v-text-field
						:loading="reportLoading"
						:model-value="!report ? '' : report['firstName']"
						:label="$gettext('First Name in CCBR')"
						:disabled="!report || !report['firstName']"
						variant="outlined"
						readonly
						hide-details
					/>
				</v-col>
				<v-col>
					<v-text-field
						:loading="reportLoading"
						:model-value="!report ? '' : report['birthCity']"
						:label="$gettext('Birth City in CCBR')"
						:disabled="!report || !report['birthCity']"
						variant="outlined"
						readonly
						hide-details
					/>
				</v-col>
				<v-col>
					<v-text-field
						:loading="reportLoading"
						:model-value="!report ? '' : report['birthCountry']"
						:label="$gettext('Birth Country in CCBR')"
						:disabled="!report || !report['birthCountry']"
						variant="outlined"
						readonly
						hide-details
					/>
				</v-col>
			</v-row>
			<v-row
				v-if="reportLoading && !report"
			>
				<v-col>
					<v-skeleton-loader
						type="paragraph"
					/>
				</v-col>
			</v-row>
			<v-row
				v-for="note in report.notes"
				v-else
				:key="note.date"
			>
				<v-col>
					<v-textarea
						:loading="reportLoading"
						:model-value="note.text"
						:label="getDate(note.date)"
						auto-grow
						variant="outlined"
						readonly
						hide-details
					/>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>
<script>
import {
	debounce,
} from 'lodash';
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'CcbrFields',
	props: {
		nameLast: {
			type: String,
			default: null,
		},
		birthDay: {
			type: String,
			required: true,
		},
		infix: {
			type: String,
			required: false,
			default: ''
		},
		modelValue: {
			type: [String, Object, null, ],
			required: false,
			default: null,
		},
		show: {
			type: Boolean,
			default: true
		}
	},

	emits: ['update:modelValue',],

	data () {
		return {
			reportLoading: true,
			report: null,
		};
	},

	watch: {
		/**
		 * Watch
		 */
		report: {
			/**
			 * Update report in parent components
			 */
			handler () {
				this.$emit('update:modelValue', this.report);
			},
		}
	},

	created () {
		this.getReport();
	},
	methods: {
		/**
		 * @param {string} dateString full ISO date string
		 * @returns {string} YYYY-MM-DD date string
		 */
		getDate (dateString) {
			const date = new Date(dateString);

			return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
		},

		/**
		 * Retrieve the CCBR report of this user
		 */
		getReport: debounce(function () {
			this.reportLoading = true;
			const infixArgument = this.infix ? `&infix=${this.infix}` : '';

			axios.get(`/bo/pending/ccbrreport?name=${this.nameLast}&birth_day=${this.birthDay}${infixArgument}`).then(({
				data
			}) => {
				if (data.inRegister) {
					this.report = data.report;
				} else {
					this.report = 'User not found in CCBR';
				}
			}).catch(() => {
				this.report = 'Could not load CCBR report';
			}).finally(() => {
				this.reportLoading = false;
			});
		})
	}
};
</script>
